import './App.css';
import  Navbar from './Components/Navbar/Navbar';
import Routes from './routes';

function App() {
  return (
    <div className="App">
      < Navbar/>
      < Routes/>
    </div>
  );
}

export default App;
